var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsThumbsDown2OutlineBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outline",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "thumb-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icons_ol_thumb-down",
    "data-name": "icons/ol/thumb-down",
    className: "cls-1",
    d: "M14,59h4.5V14H14Zm45,0H81.5A4.49,4.49,0,0,0,86,54.5v-36A4.49,4.49,0,0,0,81.5,14H32V59L45.5,72.5v6.75a6.75,6.75,0,0,0,13.5,0ZM36.5,18.5h45v36h-27V79.25a2.25,2.25,0,0,1-4.5,0V70.64L36.5,57.14Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsThumbsDown2OutlineBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_ThumbsDown2_Outline_Black_RGB.ae389c2aae869258351bf6f781f8541c.svg";
export { ForwardRef as ReactComponent };